import { render, staticRenderFns } from "./removal.vue?vue&type=template&id=2c30ee25&scoped=true&"
import script from "./removal.vue?vue&type=script&lang=js&"
export * from "./removal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30ee25",
  null
  
)

export default component.exports